import { render, staticRenderFns } from "./ClickMoreBtn.vue?vue&type=template&id=d96db30e&scoped=true&"
import script from "./ClickMoreBtn.vue?vue&type=script&lang=js&"
export * from "./ClickMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./ClickMoreBtn.vue?vue&type=style&index=0&id=d96db30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96db30e",
  null
  
)

export default component.exports